"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestChallengeEvmOperation = void 0;
var common_evm_utils_1 = require("@moralisweb3/common-evm-utils");
/** The back channel challenge containing the id to store on the api and the message to be signed by the user */
exports.requestChallengeEvmOperation = {
    method: 'POST',
    name: 'requestChallengeEvm',
    id: 'requestChallengeEvm',
    groupName: 'evm',
    urlPathPattern: '/challenge/request/evm',
    bodyParamNames: [
        'domain',
        'chainId',
        'address',
        'statement',
        'uri',
        'expirationTime',
        'notBefore',
        'resources',
        'timeout',
    ],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function getRequestBody(request, core) {
    return {
        domain: request.domain,
        chainId: common_evm_utils_1.EvmChainResolver.resolve(request.chainId, core).hex,
        address: common_evm_utils_1.EvmAddress.create(request.address, core).checksum,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request, core) {
    return {
        domain: request.domain,
        chainId: common_evm_utils_1.EvmChainResolver.resolve(request.chainId, core).decimal.toString(),
        address: common_evm_utils_1.EvmAddress.create(request.address, core).checksum,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout,
    };
}
function deserializeRequest(jsonRequest, core) {
    return {
        domain: jsonRequest.domain,
        chainId: common_evm_utils_1.EvmChainResolver.resolve(jsonRequest.chainId, core),
        address: common_evm_utils_1.EvmAddress.create(jsonRequest.address, core),
        statement: jsonRequest.statement,
        uri: jsonRequest.uri,
        expirationTime: jsonRequest.expirationTime,
        notBefore: jsonRequest.notBefore,
        resources: jsonRequest.resources,
        timeout: jsonRequest.timeout,
    };
}
//# sourceMappingURL=requestChallengeEvmOperation.js.map